import { comps } from "./RenderInput";

export default function Inline({ inputs }: FormInput) {
  if (!inputs) return <></>;
  return (
    <div className="flex  gap-4 w-full">
      {inputs.map((input, index) => {
        const Comp = (comps as any)[input.type];
        if (!Comp) return <></>;
        return (
          <Comp
            key={index}
            {...input}
            {...input.inputProps}
            style={{ width: "100%", ...input?.inputProps?.style }}
          />
        );
      })}
    </div>
  );
}
